import withNavigate from "../../../routes/withNavigate.jsx";
import PlayerEventBookingsReportsContainer from "./PlayerEventBookingsReportsContainer.jsx";
import PlayerEventBookingsReportsStore from "./PlayerEventBookingsReportsStore.js";

export default PlayerEventBookingsReportsStore(withNavigate(PlayerEventBookingsReportsContainer));